<template>
  <div class="min-h-screen page-wrapper">
    <transition name="rotate" mode="out-in">
      <div class="main-box" key="1">
        <br />
        <div class="page-title">Please fill in your details:</div>
        <br />

        <div class="mb-6">
          <label for="name" class="block mb-1 text-sm text-left"
            >Full Name</label
          >
          <input
            id="name"
            name="name"
            type="text"
            class="w-full px-4 py-2 border border-gray-300 rounded-md"
            placeholder="Full Name"
            v-model.trim="form.fields.name"
            maxlength="100"
            @blur="validateField('name')"
          />
          <FormFieldError class="mt-2" :errors="form.errors.name" />
        </div>
        <div class="mb-6">
          <label for="email" class="block mb-1 text-sm text-left">Email</label>
          <input
            name="email"
            id="email"
            type="email"
            class="w-full px-4 py-2 border border-gray-300 rounded-md"
            placeholder="Email"
            v-model.trim="form.fields.email"
            maxlength="100"
            @blur="validateField('email')"
          />
          <FormFieldError class="mt-2" :errors="form.errors.email" />
        </div>

        <div class="mb-6">
          <div class="block mb-1 text-sm text-left">Age Group</div>
          <div class="flex justify-start -mx-2">
            <button
              v-for="(age, index) in ageGroups"
              :key="`age_${index}`"
              class="w-[200px] border mx-2 rounded-md py-2 px-4"
              :class="[
                form.fields.age_group === age.key
                  ? 'bg-primaryBlue border-white text-white'
                  : 'bg-white',
              ]"
              @click="form.fields.age_group = age.key"
            >
              {{ age.value }}
            </button>
          </div>
          <FormFieldError class="mt-2" :errors="form.errors.age_group" />
        </div>

        <div class="mb-6">
          <div class="block mb-1 text-sm text-left">Gender</div>
          <div class="flex justify-start -mx-2">
            <button
              v-for="(gender, index) in genderOptions"
              :key="`gender_${index}`"
              class="w-[200px] border mx-2 rounded-md py-2 px-4"
              :class="[
                form.fields.gender === gender.value
                  ? 'bg-primaryBlue border-white text-white'
                  : 'bg-white',
              ]"
              @click="form.fields.gender = gender.value"
            >
              {{ gender.label }}
            </button>
          </div>
          <FormFieldError class="mt-2" :errors="form.errors.age_group" />
        </div>

        <div class="mb-6">
          <div class="block mb-1 text-sm text-left">College Year</div>
          <div class="flex justify-start -mx-2">
            <button
              v-for="(item, index) in collegeYears"
              :key="`cy_${index}`"
              class="w-[200px] border mx-2 rounded-md py-2 px-4"
              :class="[
                form.fields.college_year === item.value
                  ? 'bg-primaryBlue border-white text-white'
                  : 'bg-white',
              ]"
              v-html="`${item.label}`"
              @click="form.fields.college_year = item.value"
            ></button>
          </div>
          <FormFieldError class="mt-2" :errors="form.errors.college_year" />
        </div>

        <div class="mb-6">
          <label for="stateDropdown" class="block mb-1 text-sm text-left"
            >State in which college is located</label
          >
          <v-select
            :options="stateOptions"
            :reduce="(state) => state.id"
            label="name"
            v-model="selectedState"
          ></v-select>
          <!-- <select
            name="stateDropdown"
            id="stateDropdown"
            class="select-input"
            v-model="selectedState"
          >
            <option :value="null" :disabled="true">Select State</option>
            <option
              :value="state.id"
              v-for="state in stateOptions"
              :key="state.id"
            >
              {{ state.name }}
            </option>
          </select> -->
          <FormFieldError class="mt-2" :errors="form.errors.state" />
        </div>
        <!-- <div v-if="selectedState">
          <div
            v-if="!isCityOptionLoaded"
            style="margin-top: -20px; margin-bottom: 40px"
            class="flex flex-col items-center justify-center"
          >
            <img
              src="@/assets/images/loading.svg"
              alt="loading"
              style="width: 80px"
            />
            <div style="margin-top: -20px">Loading Cities</div>
          </div>
          <div v-else class="mb-6">
            <label for="cityDropdown" class="block mb-1 text-sm text-left">
              City in which college is located
            </label>
            <select
              name="cityDropdown"
              id="cityDropdown"
              :disabled="!selectedState"
              class="select-input"
              v-model="selectedCity"
            >
              <option :value="null" :disabled="true">Select City</option>
              <option
                :value="city.id"
                v-for="city in cityOptions"
                :key="city.id"
              >
                {{ city.name }}
              </option>
            </select>
            <FormFieldError class="mt-2" :errors="form.errors.city" />
          </div>
        </div> -->
        <div v-if="selectedState">
          <div
            v-if="!isDistrictOptionLoaded"
            style="margin-top: -20px; margin-bottom: 40px"
            class="flex flex-col items-center justify-center"
          >
            <img
              src="@/assets/images/loading.svg"
              alt="loading"
              style="width: 80px"
            />
            <div style="margin-top: -20px">Loading Districts</div>
          </div>
          <div v-else class="mb-6">
            <label for="districtDropdown" class="block mb-1 text-sm text-left">
              District in which college is located
            </label>
            <v-select
              :options="districtOptions"
              :reduce="(state) => state.id"
              label="name"
              v-model="selectedDistrict"
            ></v-select>
            <!-- <select
              name="districtDropdown"
              id="disrtictDropdown"
              :disabled="!selectedState"
              class="select-input"
              v-model="selectedDistrict"
            >
              <option :value="null" :disabled="true">Select District</option>
              <option
                :value="district.id"
                v-for="district in districtOptions"
                :key="district.id"
              >
                {{ district.name }}
              </option>
            </select> -->
            <FormFieldError class="mt-2" :errors="form.errors.district" />
          </div>
        </div>
        <div v-if="selectedDistrict" style="marging-bottom: 40px">
          <div>
            <div
              v-if="!isStateOptionLoaded"
              style="margin-top: -20px; margin-bottom: 40px"
              class="flex flex-col items-center justify-center"
            >
              <img
                src="@/assets/images/loading.svg"
                alt="loading"
                style="width: 80px"
              />
              <div style="margin-top: -20px">Loading Colleges</div>
            </div>
            <div v-else class="mb-6">
              <label for="collegeDropdown" class="block mb-1 text-sm text-left">
                Select College</label
              >
              <v-select
                :options="collegeOptions"
                :reduce="(state) => state.value"
                label="label"
                v-model="selectedCollege"
              ></v-select>
              <!-- <select
                name="collegeDropdown"
                id="collegeDropdown"
                :disabled="!selectedDistrict"
                class="select-input"
                v-model="selectedCollege"
              >
                <option :value="null" :disabled="true">Select College</option>
                <option
                  :value="college.value"
                  v-for="college in collegeOptions"
                  :key="college.value"
                >
                  {{ college.label }}
                </option>
              </select> -->
              <FormFieldError class="mt-2" :errors="form.errors.college" />
            </div>
          </div>
        </div>
        <!-- <div class="mb-6">
          <label for="platform" class="block mb-1 text-sm text-left">
            What is your prefered platform for watching content?</label
          >
          <select
            name="platform"
            id="platform"
            class="select-input"
            v-model="form.fields.platform"
          >
            <option :value="null" :disabled="true">Select Platform</option>
            <option
              v-for="pl in platformOptions"
              :value="pl.value"
              :key="pl.value"
            >
              {{ pl.label }}
            </option>
          </select>
          <FormFieldError class="mt-2" :errors="form.errors.platform" />
        </div> -->

        <div class="my-6 text-[10px]">
          * By registering, I agree to P&G or P&G third party agencies,
          businesses or media partners collecting and processing my Name, Mobile
          Number, Email ID, age group, and gender to (i) send me information on
          all P&G brands and their programs, offers, samples, surveys and
          service via call, SMS, email, Whatsapp, social media or other digital
          platforms for all marketing & advertising purposes, and (ii)
          contacting me for auditing/ verifying trial of P&G products. I have
          read and I agree to the P&G Privacy Policy
          <strong>
            <a
              href="https://privacypolicy.pg.com/en-IN/"
              target="_blank"
              rel="noreferrer"
              class="text-primaryBlue"
              >www.pg.com/privacy</a
            ></strong
          >
        </div>

        <button
          class="button-blue btn-submit w-[300px] mb-12"
          :class="{
            'button-blue--loading': isFormSubmitting,
            'btn-disabled': !isFormValid,
          }"
          :disabled="isFormSubmitting || !isFormValid"
          @click="submit"
        >
          <span> Submit </span>
        </button>
      </div>
    </transition>
    <Footer />
  </div>
</template>
<script setup>
import { reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import useCollegeSelect from '@/hooks/useCollegeSelect'
import useValidateForm from '@/hooks/useValidateForm'
import FormFieldError from '@/components/FormFieldError.vue'
import Footer from '@/components/Footer.vue'
import {
  ageGroups,
  collegeYears,
  // platformOptions,
  genderOptions,
} from '@/constants'
import { updateParticipantInfo } from '../api'
import useEventCheck from '@/hooks/useEventCheck'

const {
  stateOptions,
  selectedState,
  // cityOptions,
  // selectedCity,
  districtOptions,
  selectedDistrict,
  collegeOptions,
  selectedCollege,
  // isCityOptionLoaded,
  isDistrictOptionLoaded,
  isStateOptionLoaded,
} = useCollegeSelect()
const { push } = useRouter()

const isFormSubmitting = ref(false)
const isFormValid = ref(false)

useEventCheck()

const form = reactive({
  fields: {
    name: null,
    email: null,
    age_group: null,
    gender: null,
    college_year: null,
    state: null,
    // city: null,
    district: null,
    college: null,
    // platform: null,
  },
  validations: {
    name: [
      {
        name: 'required',
        message: 'Please enter your full name',
      },
    ],
    email: [
      {
        name: 'required',
        message: 'Please enter your email',
      },
      {
        name: 'email',
        message: 'Please enter a valid email',
      },
    ],
    age_group: [
      {
        name: 'required',
        message: 'Please select your age group',
      },
    ],
    gender: [
      {
        name: 'required',
        message: 'Please select your gender',
      },
    ],
    college_year: [
      {
        name: 'required',
        message: 'Please select your college year',
      },
    ],
    state: [
      {
        name: 'required',
        message: 'Please select your state',
      },
    ],
    // city: [
    //   {
    //     name: 'required',
    //     message: 'Please select your city',
    //   },
    // ],
    district: [
      {
        name: 'required',
        message: 'Please select your district',
      },
    ],
    college: [
      {
        name: 'required',
        message: 'Please select your college',
      },
    ],
  },
  errors: {
    name: null,
    email: null,
    age_group: null,
    college_year: null,
    gender: null,
    state: null,
    // city: null,
    district: null,
    college: null,
    // platform: null,
  },
})

// watch(
//   () => selectedCity.value,
//   (val) => {
//     form.errors.city = null
//     form.fields.city = val
//   },
// )

watch(
  () => selectedDistrict.value,
  (val) => {
    form.errors.district = null
    form.fields.district = val
  },
)

watch(
  () => selectedState.value,
  (val) => {
    form.errors.state = null
    form.fields.state = val
  },
)

watch(
  () => selectedCollege.value,
  (val) => {
    form.errors.college = null
    form.fields.college = val
  },
)

const { validateForm, validateField } = useValidateForm(form)

watch(
  () => form.fields,
  () => {
    isFormValid.value = validateForm(false)
  },
  { deep: true },
)

const submit = async () => {
  isFormSubmitting.value = true
  const isValid = validateForm()
  if (isValid) {
    const { data, status } = await updateParticipantInfo(form.fields)
    if (status === 400) {
      Object.assign(form.errors, data)
      isFormSubmitting.value = false
      window.scrollTo(0, 0)
    } else if (status === 200) {
      push({ name: 'done' })
    }
  } else {
    isFormSubmitting.value = false
  }
}
</script>
<style>
@import 'vue-select/dist/vue-select.css';
.vs__dropdown-toggle {
  background-color: #fff !important;
  padding: 8px;
  width: 100%;
  border-radius: 9px;
  border: 2px solid #e4e4e4;
}
</style>
